const menu = {
    single_sign_on: 'Início de sessão único',
    profile: 'Perfil',
    language: 'Linguagem',
    appearance: {
        label: 'Aparência',
        light: 'Claro',
        dark: 'Escuro',
        system: 'Sincronizar com o sistemam',
    },
    sign_out: 'Terminar sessão',
};
export default Object.freeze(menu);
